import { Injectable } from '@angular/core';
import { Http, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class ReviewService {
  constructor(public http: Http) {}

  createReview(restaurant_id: number, review: {}) {
    return this.http.post(`${API_URL}/api/v1/restaurants/${restaurant_id}/reviews`, {review: review}).map(res => {
      return res.json();
    });
  }

  getReviews(client_id: number, page: number) {
    let params = new URLSearchParams();
    params.set('page', page.toString());
    return this.http.get(`${API_URL}/api/v1/clients/reviews`, { search: params }).map(res => {
      return res.json();
    });
  }

  getRestaurantReviews(restaurant_id: number, page: number, user_id?: number) {
    let params = { page: page, user_id: user_id }
    return this.http.get(`${API_URL}/api/v1/restaurants/${restaurant_id}/reviews`, { search: params }).map(res => {
      return res.json();
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/reviews.ts